import React, { useState, useEffect, useContext } from "react";
import { IoCloseOutline } from "react-icons/io5";
import { useForm, Controller } from "react-hook-form";
import masterApi from "../../services/masterApi"; // Ensure correct import path
import jobApi from "../../services/jobApi";
import "./JobDetails.scss";
import { MultiSelect } from "primereact/multiselect";
import { toast } from "react-toastify";
import { AssignContext } from "../../context/AssignContext";

export default function AssignTo({ closePopup, boardId, mappingId, assigneeList, reloadData }) {
  const {selectedAssigneeList} = useContext(AssignContext)
  const { control, handleSubmit, setValue } = useForm({
    defaultValues: {
      assigneeId: assigneeList.map((user) => ({
        name: `${user.firstName} ${user.lastName}`,
        code: user.assigneeId,
      })) || [] // Set default selected values
    }
  });
  const [usersLst, setUsersLst] = useState([]);
  const [boardLst, setBoardLst] = useState([]);

  useEffect(() => {
    console.log(assigneeList.map(assignee => assignee.assigneeId) || []);
    const fetchData = async () => {
      try {
        const userResponse = await masterApi.getActiveUsers();
        const userFormattedData = userResponse?.data?.users?.map((user) => ({
          name: `${user.firstName} ${user.lastName}`,
          code: user.id,
        }));
        setUsersLst(userFormattedData);

        const boardResponse = await masterApi.getActiveBoard();
        const boardFormattedData = boardResponse?.data?.activeboards?.map((board) => ({
          name: board.boardName,
          code: board.id,
        }));
        setBoardLst(boardFormattedData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (boardLst.length > 0 && boardId) {
      setValue("boardId", boardId);
    }
  }, [boardLst, boardId, setValue]);

  const onSubmit = async (data) => {

    data.mappingId = mappingId;
    console.log("Form Data:", data);
    const updatedData = {
      ...data,
      assigneeId: data.assigneeId.map(assignee => assignee.code)
    };
    try{
      const response = await jobApi.updateCandidateAssignee(updatedData);
      console.log(response);
      if (response?.data?.ok) {
        selectedAssigneeList.current = data.assigneeId
          toast.success("Candidate assignee updated successfully", {
                  position: "top-right",
                  autoClose: 2000,
                })
          reloadData();
          closePopup(); // Close after submitting
        }
    }catch (error) {
      toast.error("Error updating assignee", {
              position: "top-right",
              autoClose: 2000,
            })
        console.error("Error updating assignee:", error);
    }

  };

  return (
    <div className="popup-container center-popup">
      <div className="shadeClose" onClick={closePopup}></div>
      <div className="popup-inner">
        <div className="inner-design">
          <div className="popup-header d-flex align-items-center gap2">
            <h2>Assign</h2>
            <button type="button" className="ms-auto close-btn" onClick={closePopup}>
              <IoCloseOutline />
            </button>
          </div>

          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="popup-content">
              <div className="row">
                {/* Phase Dropdown */}
                <div className="col-12 col-md-12 mb-4 position-relative">
                  <label className="form-label">Phase</label>
                  <Controller
                    name="boardId"
                    control={control}
                    render={({ field }) => (
                      <select className="form-select" {...field} disabled>
                        <option value="">Select Board</option>
                        {boardLst.map((board) => (
                          <option key={board.code} value={board.code}>
                            {board.name}
                          </option>
                        ))}
                      </select>
                    )}
                  />
                </div>

                {/* Assigned To */}
                <div className="col-12 col-md-12 position-relative">
                  <label className="form-label">
                    Assigned to <span className="asterisk danger">*</span>
                  </label>
                  <div className="d-flex prime-holder">
                    <Controller
                      name="assigneeId"
                      control={control}
                      //defaultValue={[]} // Set the initial state as an empty array
                      rules={{ required: "Please select at least one assignee" }}
                      render={({ field }) => (
                        <MultiSelect
                          {...field}
                          options={usersLst}
                          value={field.value} // Bind the selected value
                          onChange={(e) => field.onChange(e.value)}
                          optionLabel="name"
                          display="chip"
                          placeholder="Select Assignee"
                          maxSelectedLabels={3}
                          className={`w-full md:w-20rem form-control`}
                        />
                      )}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Footer Buttons */}
            <div className="popup-footer w-100 d-flex">
              <div className="ms-auto d-flex gap-2">
                <button type="button" className="btn btn-dark" onClick={closePopup}>
                  Cancel
                </button>
                <button type="submit" className="btn btn-success">
                  Done
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
